import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useNotifications } from '@/contexts/NotificationContext';

/**
 * RequireSubscription Guard
 * Redirects users without active subscription to account page
 * Shows toast notification explaining subscription requirement
 */
export default function RequireSubscription({ children }) {
  const { isSubscribedActive } = useAuth();
  const { addToast } = useNotifications();
  const location = useLocation();
  const hasShownToast = useRef(false);

  const isActive = isSubscribedActive();

  useEffect(() => {
    if (!isActive && !hasShownToast.current) {
      hasShownToast.current = true;
      addToast({
        type: 'warning',
        title: 'Abonnement requis',
        description: 'Cette fonctionnalité nécessite un abonnement actif.',
        duration: 8000
      });
    }
  }, [isActive, addToast]);

  if (!isActive) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/account?subscribe=1&next=${next}`} replace />;
  }

  return children;
}
